import { getPlaceDetails } from '../placeSlice'
import { useParams } from 'react-router-dom'
import { useReduxDispatch } from 'store'
import { useEffect } from 'react'

const useFreshPlaceData = () => {
  const { placeId } = useParams<{ placeId: string }>()
  const dispatch = useReduxDispatch()

  useEffect(() => {
    const fetchData = () => {
      dispatch(getPlaceDetails(placeId))
    }

    fetchData()
    const timeout = setInterval(fetchData, 15_000)
    return () => {
      clearInterval(timeout)
    }
  }, [placeId, dispatch])
}

export default useFreshPlaceData